namespace TabAurous.Production {
    export namespace WIPTransactionBagWiseService {
        export const baseUrl = 'Production/WIPTransactionBagWise';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<WIPTransactionRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "Production/WIPTransactionBagWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>WIPTransactionBagWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
